import $ from 'jquery';
import Litepicker from 'litepicker';
import customSelect from './custom-select';
import Inputmask from "inputmask";

const cf7                         = {
	selectData : {},

	init: function() {
		if ( complaint_form.topics ) {
			cf7.selectData = complaint_form.topics;
		}

		const checkPage = document.querySelector( '.contact-form' );
		if ( checkPage == null ) {
			return;
		}
		let email            = $( '.contact-form__form--suggestions' ).find( '.wpcf7-email' ),
			phone            = $( '.contact-form__form--suggestions' ).find( '.wpcf7-tel' ),
			name			 = $( '.contact-form__form--suggestions' ).find( '.form-name' ),
			name_acceptance  = $( '.contact-form__form-checkbox--basic' ),
			selects          = $( '.contact-form' ).find( 'select' ),
			email_acceptance = $( '.contact-form__form-checkbox--email' ),
			link             = $( '.contact-form__form-checkbox--email' ).find( 'a#dynamic-link' ),
			phone_acceptance = $( '.contact-form__form-checkbox--phone' ),
			suggestions_box  = $( '.contact-form__form--suggestions' ).find( '.suggestions-acceptance' );

		$( selects ).each(
			function() {
				$( this ).children().each(
					function(i) {
						$( this ).attr( 'data-number', i )
					}
				)
			}
		)

		$( selects ).on(
			'change',
			function () {
				let option = $( 'option:selected', this ).attr( 'data-number' );
				if ( option === '1' ) {
					$( link ).attr( 'href', suggestions.link_insurance_property.url )
				} else if ( option === '2' ) {
					$( link ).attr( 'href', suggestions.link_insurance_live.url )
				}
			}
		)

		function show_hide_checkbox(input, checkbox) {
			$( input ).on(
				'keyup',
				function() {
					if ( $( this ).val().length > 1 ) {
						checkbox.show();
					} else {
						checkbox.hide();
					}
				}
			)
		}
		show_hide_checkbox( email, email_acceptance );
		show_hide_checkbox( phone, phone_acceptance );

		function show_hide_many_field(inputs, element) {
			$( inputs ).on(
				'keyup',
				function() {
					let inputText = '';
					$( inputs ).each( function() {
						inputText += $( this ).val();
					})

					if ( inputText.length === 0 ) {
						element.hide();
					} else {
						element.show();
					}
				}
			)
		}

		show_hide_many_field( name, name_acceptance );
		if ( email.length > 0 ) {
			show_hide_many_field( [email[0], phone[0], ...name], suggestions_box );
		}


		this.callUsBackFields();
		this.litepickerInit();
		this.numbersOnly();
		this.phoneNumbersFormat();
		this.zipCodeFormat();
		this.acceptances();
		this.visibleHours();
		this.complaintForm();
		this.complaintFormRadioAsSwitcher();
		this.inputState();
		this.fileInput();

		this.initFileDropzone();
		this.initComplaintFormEvents();
	},
	numbersOnly() {
		let ele = document.querySelectorAll('.wpcf7-numbers-only');
		ele.forEach(function (el) {
			el.onkeypress = function(e) {
				if ( isNaN( this.value+""+String.fromCharCode( e.charCode ) ) )
					return false;
			}
			el.onpaste = function(e){
				e.preventDefault();
			}
		})
	},
	phoneNumbersFormat() {
		const phones = document.querySelectorAll('.wpcf7-tel');

		if ( ! phones.length ) {
			return;
		}

		phones.forEach( (phone) => {
			let plPlaceholder = "999-999-999";
			let plPhoneMask = new Inputmask(plPlaceholder);
			plPhoneMask.mask(phone);
			phone.placeholder = plPlaceholder;
		})
	},
	zipCodeFormat() {
		const zipCodes = document.querySelectorAll('.zip-code-format');

		if ( ! zipCodes.length ) {
			return;
		}

		zipCodes.forEach( (zipCode) => {
			let plZipCodePlaceholder = "99-999";
			let plZipCodeMask = new Inputmask(plZipCodePlaceholder);
			plZipCodeMask.mask(zipCode);
			zipCode.placeholder = plZipCodePlaceholder;
		})
	},
	callUsBackFields() {
		let select_insurance_type = $( '.custom-select-insurance' ),
			select_topic_property = $( '.custom-select-topic-property' ).parent(),
			select_topic_live     = $( '.custom-select-topic-live' ).parent();

		function reset_custom_select(select) {
			$( select ).prop( 'selectedIndex',0 );
			let selected = $( select ).find( 'option:selected' ).text();
			$( select ).next().text( selected )
			$( select ).trigger( 'change' )
		}

		$( select_topic_live ).css( 'display','none' )

		$( select_insurance_type ).on(
			'change',
			function() {

				let option = $( 'option:selected', this ).attr( 'data-number' );
				if ( option === '1' ) {
					$( select_topic_property ).css( 'display','block' )
					$( select_topic_live ).css( 'display','none' )
					reset_custom_select( '.custom-select-topic-live' )
					reset_custom_select( '.custom-select-topic-property' )
				} else {
					$( select_topic_property ).css( 'display','none' )
					$( select_topic_live ).css( 'display','block' )
					reset_custom_select( '.custom-select-topic-live' )
					reset_custom_select( '.custom-select-topic-property' )
				}
			}
		)

		this.tooltips()
		this.dynamicFields()


	},
	tooltips() {
		function append_tooltip_to_option(options,tooltips) {
			options.each(
				function () {
					let tooltip = $( tooltips.find( `[data-value="${$(this).attr('rel')}"]` ) );
					tooltip.addClass( 'option-tooltip' )

					$( this ).append( tooltip )

				}
			)
		}
		$( document ).ready(
			function() {
				let tooltips_property = $( '.custom-select-topic-property-tooltip' ),
					tooltips_live         = $( '.custom-select-topic-live-tooltip' ),
					options_property      = $( '.custom-select-topic-property' ).next().next().children(),
					options_live          = $( '.custom-select-topic-live' ).next().next().children();

				append_tooltip_to_option( options_property,tooltips_property )
				append_tooltip_to_option( options_live,tooltips_live )

			}
		)


	},
	dynamicFields() {
		let insurance_select_type_field   = $( '.-js-select-insurance-type' ),
			insurance_select_number_field = $( '.-js-select-insurance-number' ),
			topic_property                = $( '.custom-select-topic-property' ),
			topic_live                    = $( '.custom-select-topic-live' ),
			show_select_field_for_topics  = $( insurance_select_type_field ).attr( 'data-show-for-topics' ).split( ',' ),
			show_number_field_for_topics  = $( insurance_select_number_field ).attr( 'data-show-for-topics' ).split( ',' );

		$( insurance_select_type_field ).css( 'display','none' );
		$( insurance_select_number_field ).css( 'display','none' );
		$( topic_property ).on(
			'change',
			function() {

				if ( show_number_field_for_topics.includes( $( this ).val() ) ) {
					$( insurance_select_number_field ).css( 'display','block' );
				} else {
					$( insurance_select_number_field ).css( 'display','none' );
				}
			}
		)
		$( topic_live ).on(
			'change',
			function() {

				if ( show_select_field_for_topics.includes( $( this ).val() ) ) {
					$( insurance_select_type_field ).css( 'display','block' );
				} else {
					$( insurance_select_type_field ).css( 'display','none' );
				}

				if ( show_number_field_for_topics.includes( $( this ).val() ) ) {
					$( insurance_select_number_field ).css( 'display','block' );
				} else {
					$( insurance_select_number_field ).css( 'display','none' );
				}
			}
		)

	},
	acceptances() {
		this.statement = {
			'value' : false,
			'one'   : '* Oświadczam, że zapoznałem się z treścią dokumentu <a target="_blank" href="https://www.compensa.pl/fileadmin/user_upload/OI/CNL-OI-oferta.pdf">Obowiązek informacyjny administratora danych osobowych - oferta produktowa</a>, który został mi przedstawiony jako osobie, której dane dotyczą.',
			'two'   : '* Oświadczam, że zapoznałem się z treścią dokumentu <a target="_blank" href="https://www.compensa.pl/fileadmin/user_upload/OI/CNL-OI-szkoda.pdf">Obowiązek informacyjny administratora danych osobowych - szkody</a>, który został mi przedstawiony jako osobie, której dane dotyczą.',
			'three' : '* Oświadczam, że zapoznałem się z treścią dokumentu <a target="_blank" href="https://www.compensa.pl/fileadmin/user_upload/OWU/RODO/Formularze_i_wnioski/Obowiazek_Informacyjny_Administratora_Danych_Osobowych_CL_2019.04.09.pdf">Obowiązek informacyjny administratora danych osobowych - oferta produktowa</a>, który został mi przedstawiony jako osobie, której dane dotyczą.',
			'four'  : '* Oświadczam, że zapoznałem się z treścią dokumentu <a target="_blank" href="https://www.compensa.pl/fileadmin/user_upload/OWU/RODO/Formularze_i_wnioski/Klauzula_Informacyjna_ADO.pdf">Obowiązek informacyjny administratora danych osobowych - roszczenia/świadczenia</a>, który został mi przedstawiony jako osobie, której dane dotyczą.',
		}
		this.consent = {
			'value' : false
		}

		let statement 		 = $( ' .-js-acceptance-statement ' ),
			statement_text 	 = $( ' .-js-acceptance-statement ' ).find(' .-js-contact-form__statement '),
			consent   		 = $( ' .-js-acceptance-consent ' ),
			topic_property 	 = $( ' .custom-select-topic-property ' ),
			topic_live 		 = $( ' .custom-select-topic-live ' );

		this.acceptance_status( statement, consent );

		$( topic_property ).on(
			'change',
			() => {

				let option_topic = $( 'option:selected', topic_property ).attr( 'data-number' );

				switch ( option_topic ) {
					case '1' :
						this.statement.value = true
						this.consent.value = true
						statement_text.html( this.statement.one )
						break;
					case '2' :
						this.statement.value = true
						this.consent.value = true
						statement_text.html( this.statement.one )
						break;
					case '5' :
						this.statement.value = true
						this.consent.value = false
						statement_text.html( this.statement.two )
						break;
					default :
						this.statement.value = false
						this.consent.value = false
				}

				this.acceptance_status( statement, consent )
			}
		)

		$( topic_live ).on(
			'change',
			() => {
				let option_topic = $( 'option:selected', topic_live ).attr( 'data-number' );

				switch ( option_topic ) {
					case '1' :
						this.statement.value = true
						this.consent.value = true
						statement_text.html( this.statement.three )
						break;
					case '2' :
						this.statement.value = true
						this.consent.value = true
						statement_text.html( this.statement.three )
						break;
					case '5' :
						this.statement.value = true
						this.consent.value = false
						statement_text.html( this.statement.four )
						break;
					default :
						this.statement.value = false
						this.consent.value = false
				}

				this.acceptance_status( statement, consent )
			}
		)
	},
	acceptance_status( statement, consent ) {
		if( this.statement.value === false ) {
			statement.parent().parent().css( 'display','none' )
		} else {
			statement.parent().parent().css( 'display','block' )
		}
		if( this.consent.value === false ) {
			consent.parent().parent().css( 'display','none' )
		} else {
			consent.parent().parent().css( 'display','block' )
		}
	},
	litepickerInit() {
		let day            = new Date(),
			$this = this;
		day.setDate(day.getDate()-1);
		const element = document.querySelector( '#litepicker-cf7' ),
			parentEl = document.querySelector( '.calendar-cf7' );

		if( !element && !parentEl ) return;

		this.litepicker2          = new Litepicker(
			{
				element: element,
				parentEl: parentEl,
				singleMode: true,
				showTooltip: false,
				minDate: day,
				lang: "pl-PL",
				setup: (picker) => {
					picker.on(
						'selected',
						(initialDate,endingDate) => {
							document.querySelector( '.calendar-cf7' ).classList.add( 'var_fill' )
							var d = initialDate.dateInstance.getDate();
							var m     = initialDate.dateInstance.getMonth();
							m        += 1;  // JavaScript months are 0-11
							var y     = initialDate.dateInstance.getFullYear();
							$( 'input[name="text-for-date"]' ).attr( 'value',y + '-' + m + '-' + d );

							let date = new Date(),
								dd = date.getDate(),
								mm = date.getMonth(),
								yy = date.getFullYear();
							mm += 1;

							let picked_day = `${y}-${m}-${d}`,
								today = `${yy}-${mm}-${dd}`;
							console.log(picked_day,today)

							if(picked_day == today) {
								$this.visibleHours();
							} else {
								$this.visibleHours(true)
							}
						}
					)
					picker.on(
						'before:show',
						() => {
							document.querySelector( '.calendar-cf7' ).classList.add( 'var_active' )
						}
					)
					picker.on(
						'change:month',
						(date, calendarIdx) => {
							console.log( calendarIdx )
						}
					)
					picker.on(
						'hide',
						() => {
							document.querySelector( '.calendar-cf7' ).classList.remove( 'var_active' )
						}
					)
					picker.on(
						'render',
						(ui) => {
							//this.styleSelect()
							document.querySelector( '.calendar-cf7  .month-item' ).appendChild( document.querySelector( '.reset-button-custom-cf7' ) )

						}
					)
					picker.on(
						'clear:selection',
						() => {
							document.querySelector( '.calendar-cf7' ).classList.remove( 'var_active' )
							document.querySelector( '.calendar-cf7' ).classList.remove( 'var_fill' )
						}
					);
				},
				resetButton: () => {
					let btn       = document.createElement( 'button' );
					btn.innerText = 'Wyczyść';
					btn.className = "reset-button-custom reset-button-custom-cf7"
					btn.addEventListener(
						'click',
						(evt) => {
							evt.preventDefault();
						}
					);

					return btn;
				},
				lockDaysFilter: (day) => {
					const d = day.getDay();

					return [6, 0].includes(d);
				}
			}
		)

	},
	visibleHours(reset = false) {
		let  hours = $('.radio-hour').children().children(),
			borderTime = new Date(),
			firstTimeString = this.setTime(8, 0, 0),
			secondTimeString = this.setTime(11, 0, 0),
			thirdTimeString = this.setTime(13, 0, 0),
			fourthTimeString = this.setTime(15, 0, 0)

		borderTime.setHours( borderTime.getHours() + 2 );
		let borderTimeString = borderTime.toLocaleTimeString();

		if(reset === false) {
			if(borderTimeString > firstTimeString) {
				hours.eq(0).find('input').attr('disabled',true).next().css('opacity','.5')
			}
			if(borderTimeString > secondTimeString) {
				hours.eq(1).find('input').attr('disabled',true).next().css('opacity','.5')
			}
			if(borderTimeString > thirdTimeString) {
				hours.eq(2).find('input').attr('disabled',true).next().css('opacity','.5')
			}
			if(borderTimeString > fourthTimeString) {
				hours.eq(3).find('input').attr('disabled',true).next().css('opacity','.5')
			}
		} else {
			hours.each(function() {
				$(this).find('input').attr('disabled',false).next().css('opacity','1')
			})
		}
	},
	setTime(hours, minutes, seconds) {
		const getTime = new Date();
		getTime.setHours(hours);
		getTime.setMinutes(minutes);
		getTime.setSeconds(seconds);

		const getTimeString = getTime.toLocaleTimeString();

		return getTimeString;
	},
	setPickerMonth( date,calendarIdx ) {
	},
	styleSelect() {
		$( '.litepicker select' ).each(
			function(){

				var $this = $( this ), numberOfOptions = $( this ).children().length;
				$this.find( 'option:first-child' ).attr( 'value', 'hide' );
				$this.addClass( 'select-hidden' );
				$this.wrap( '<div class="select"></div>' );
				$this.after( '<div class="select-styled"></div>' );

				var label = $this.attr( 'data-label' );
				if ( label ) {
					$this.before( `<div class="select-label">${label}</div>` );
				}

				var $styledSelect = $this.next( 'div.select-styled' );
				$styledSelect.text( $this.children().eq( 0 ).text() );

				var $list = $(
					'<ul />',
					{
						'class': 'select-options'
					}
				).insertAfter( $styledSelect );

				for (var i = 0; i < numberOfOptions; i++) {
					$(
						'<li />',
						{
							html: $this.children().eq( i ).html(),
							rel: $this.children().eq( i ).html(),
							disabled:$this.children().eq( i ).attr( 'disabled' )
						}
					).appendTo( $list );
				}

				var $listItems = $list.children( 'li' );

				$styledSelect.click(
					function(e) {
						e.stopPropagation();
						$( 'div.select-styled.active' ).not( this ).each(
							function(){
								$( this ).removeClass( 'active' ).next( 'ul.select-options' ).hide();
							}
						);
						$( this ).toggleClass( 'active' ).next( 'ul.select-options' ).toggle();
					}
				);

				$listItems.each(
					function () {
						$( this ).wrapInner( '<span class="select-options__text"></span>' )
					}
				)

				$listItems.click(
					function(e) {
						e.stopPropagation();
						$styledSelect.text( $( this ).attr( 'rel' ) ).removeClass( 'active' );
						$styledSelect.addClass( 'selected' );
						$this.val( $( this ).attr( 'rel' ) );
						$list.hide();
						$this.trigger( 'change' );
						//console.log($this.val());
					}
				);

				$( document ).click(
					function() {
						$styledSelect.removeClass( 'active' );
						$list.hide();
					}
				);

			}
		);
	},
	setPlaceholders() {
		$( '.contact-form__placeholder' ).each(( index, el ) => {
			const parent = $( el ).next();
			const isSelect = $(parent).children().find('select')

			if ( isSelect.length > 0 ) {
				$( isSelect[0].parentNode ).append( el )
			} else {
				if( parent.length > 0 && !parent.is('.wpcf7-not-valid-tip') ){
					$( parent ).append( el );
				}
			}
		})
	},
	inputState() {
		let wpcf7Elm = document.querySelector( '.wpcf7' );

		wpcf7Elm.addEventListener( 'wpcf7invalid', ( event ) => {
			const target = event.target;

			setTimeout(function(){
				const invalidElements = $( target ).find('.wpcf7-not-valid-tip');

				$(invalidElements).each( ( index, el ) => {
					const isSelect = $(el.parentElement).children().find('select')
					const warningText = $( el ).text();

					if ( isSelect.length > 0 ) {
						const select = $( el ).siblings( '.select' );
						const label = select.find( 'label' )[0];

						const isAlreadyInvalid = $( label ).find( 'span' );

						if ( isAlreadyInvalid.length === 0 ) {
							$( label ).append( `<span>${warningText}</span>` );
						}
					} else {
						const label = $( el ).siblings( 'label' );
						const isAlreadyInvalid = label.find( 'span' );

						if ( isAlreadyInvalid.length === 0 ) {
							label.append( `<span>${warningText}</span>` );
						}
					}
				})
			});

		}, false );

		$( '.contact-form__input' ).focusout(function( el ) {
			const isFilled = this.value.trim().length

			if ( isFilled > 0 ) {
				$( this ).addClass( 'is_filled' );
				const label = $( this ).siblings( 'label' )

				const isInvalid = label.find( 'span' ).length;

				if ( isInvalid > 0 ) {
					$( label ).children()[0].remove();
				}
			} else {
				$( this ).removeClass( 'is_filled' );
			}
		})
	},
	complaintForm() {
		const form = document.querySelector('.contact-form__complaint');
		if ( ! form ) {
			return
		}
		function fillSelectWithNewOptions(optionEl, select) {
			const optionItem = document.createElement('option');
			optionItem.setAttribute('value', optionEl)
			optionItem.innerText = optionEl
			select.appendChild(optionItem)
		}
		const select = form.querySelector('.complaint-select');

		if( select ) {
			select.innerHTML = '';
			const optionElement = document.createElement( 'option' );
			optionElement.text = '';
			optionElement.value = 'hide';
			select.appendChild( optionElement )

			Object.keys(this.selectData).forEach( function(optionEl) {
				fillSelectWithNewOptions(optionEl, select)
			})
		}

	},
	complaintFormAppendSelect() {
		const form = document.querySelector('.contact-form__complaint');
		if ( ! form ) {
			return
		}
		// Get Placeholder Select and remove it, so we can manage this option in ACF plugin
		const removeSelect = form.querySelector('.remove-select');
		removeSelect.remove();

		function add_dynamic_child_select(select, selectChildLabel) {
			const existingChildSelect = form.querySelector('.generated-select');
			if(existingChildSelect) {
				existingChildSelect.parentNode.remove()
			}
			const childSelect = document.createElement('select');
			childSelect.classList.add('generated-select','wpcf7-form-control','wpcf7-select')
			childSelect.setAttribute('name', 'complaint-type-child');
			childSelect.setAttribute('aria-invalid', 'false');
			select.appendChild(selectChildLabel)
			select.appendChild(childSelect)
		}
		const select = form.querySelector('.complaint-select');
		const selectChildList = form.querySelector('span[data-name="complaint-type-child"]');
		const selectChildLabel = form.querySelector('.contact-form__placeholder--complaint-child');
		selectChildLabel.remove();
		$(select).on('change',() => {
			add_dynamic_child_select(selectChildList, selectChildLabel);
			const childSelect = form.querySelector('.generated-select');
			this.selectData[select.value].forEach(function(optionEl) {
				const optionItem = document.createElement('option');
				optionItem.setAttribute('value', optionEl)
				optionItem.innerText = optionEl
				childSelect.appendChild(optionItem)
			})
			customSelect.customSelect('.generated-select')
			this.setPlaceholders()
		})
	},
	complaintFormRadioAsSwitcher() {
		const form = document.querySelector('.contact-form__complaint');
		if( ! form ) {
			return
		}
		const radioSwitcherForRegonOrPesel = form.querySelectorAll('input[name="pes-reg"]');
		const regonOrPeselSwitcherControler = form.querySelector('.-js-switcher-pes-reg');
		if(radioSwitcherForRegonOrPesel) {
			radioSwitcherForRegonOrPesel.forEach(function (radio) {
				radio.addEventListener('change', function () {
					let regonOrPesel = regonOrPeselSwitcherControler.querySelectorAll(`.form-${radio.value}`);
					let regonOrPeselParent = $(regonOrPesel).parent().parent();
					regonOrPesel.value = '';
					$(regonOrPeselParent).siblings().removeClass('active')
					if ( regonOrPeselParent.hasClass('active') ) {
						regonOrPeselParent.removeClass('active')
					} else {
						regonOrPeselParent.addClass('active')
					}
				})
			})
		}
		const radioSwitcherForEmail = form.querySelectorAll('input[name="mail-or-email"]');
		const emailInput = form.querySelector('.form-input__email');
		const emailInputParent = $(emailInput).parent().parent();
		if (radioSwitcherForEmail) {
			radioSwitcherForEmail.forEach(function (radio) {
				radio.addEventListener('change', function () {
					emailInput.value = ''
					if (radio.value == 'na adres mailowy') {
						emailInputParent.addClass('active')
					} else {
						emailInputParent.removeClass('active')
					}
				})
			})
		}
	},
	fileInput() {
		const fileInput = document.querySelectorAll('.file');
		if (fileInput.length > 0) {
			fileInput.forEach(function (file) {
				const fileInput = file.querySelector('input');

				const button = document.createElement('div')
				const uploadedFileDiv = document.createElement('div');
				uploadedFileDiv.classList.add('file-information')
				button.classList.add('main-button')
				button.innerText = 'Załącz plik'
				file.appendChild(button)

				$(fileInput).on('change', function () {
					const fileName = fileInput.value.split(/(\\|\/)/g).pop();
					uploadedFileDiv.innerHTML = `Plik&nbsp;<strong>${fileName}</strong>&nbsp;został załączony. <div class="remove-file">x</div>`;
					file.appendChild(uploadedFileDiv);
					const removeFile = document.querySelector('.remove-file');
					$(removeFile).on('click', function () {
						fileInput.value = ''
						uploadedFileDiv.remove()
					})
				})
			})
		}
	},
	initFileDropzone: () => {
		const dropzoneWrappers = document.querySelectorAll(`[data-form-dropzone]`);
		dropzoneWrappers.forEach((dropzoneWrapper) => {
		    const dropzone = dropzoneWrapper.querySelector('[data-form-dropzone-drop]');
		    const progressWrapper = dropzoneWrapper.querySelector('[data-form-dropzone-progress]');
		    const fileInput = dropzoneWrapper.querySelector('input[type="file"]');
			if(!dropzone || !progressWrapper) return;

			dropzone.addEventListener('dragenter', (ev) => {
				ev.preventDefault();
				dropzone.classList.add('active');
			})
			dropzone.addEventListener('dragover', (ev) => {
				ev.preventDefault();
				dropzone.classList.add('active');
			})
			dropzone.addEventListener('dragleave', (ev) => {
				ev.preventDefault();
				dropzone.classList.remove('active');
			})
			dropzone.addEventListener('drop', (ev) => {
				ev.preventDefault();
				dropzone.classList.remove('active');

				const dt = ev.dataTransfer;
				const files = dt.files;
				if(files.length === 0) return;
				const file = files[0];

				console.log(file);
				if(!cf7.fileIsValid(file, fileInput)){
					window.alert("Plik nie spełnia wymagań dotyczących rozmiaru lub rozszerzenia.");
					return;
				}

				const inputDataTransfer = new DataTransfer();
				inputDataTransfer.items.add(file);
				fileInput.files = inputDataTransfer.files;

				fileInput.dispatchEvent(new Event('change'));

			})

			fileInput.addEventListener('change', (ev) => {
				ev.target.files;
				progressWrapper.innerHTML = '';
				for (const file of ev.target.files) {
					cf7.appendProgressFileElement(progressWrapper, file, fileInput);
				}
			})
		})
	},
	appendProgressFileElement: (progressWrapper, file, fileInput) => {
		let itemElement = document.createElement('div');
		itemElement.classList.add('uploaded-item');

		let deleteButtonElement = document.createElement('button');
		deleteButtonElement.setAttribute('type', 'button');
		deleteButtonElement.classList.add('uploaded-item__delete');

		deleteButtonElement.addEventListener('click', (ev) => {
			ev.preventDefault();
			fileInput.value = null;
			progressWrapper.innerHTML = '';
		})

		let nameElement = document.createElement('span');
		nameElement.innerText = file.name;
		nameElement.classList.add('uploaded-item__name');

		let sizeElement = document.createElement('span');
		sizeElement.innerText = cf7.bytesToText(file.size);
		sizeElement.classList.add('uploaded-item__size');

		let progressElement = document.createElement('div');
		progressElement.classList.add('uploaded-item__progress');
		progressElement.style.width = '0%';

		let percentElement = document.createElement('span');
		percentElement.innerText = '0%';
		percentElement.classList.add('uploaded-item__percent');

		let iconElement = document.createElement('img');
		iconElement.src = '/app/themes/osom-theme/src/img/icons/file-lines.svg';
		iconElement.classList.add('uploaded-item__icon');

		let topWrapper = document.createElement('div');
		topWrapper.classList.add('uploaded-item__top');

		let topRightWrapper = document.createElement('div');
		topRightWrapper.classList.add('uploaded-item__top__right');

		let topRowWrapper = document.createElement('div');
		topRowWrapper.classList.add('uploaded-item__top__row');

		let topRowWrapper2 = document.createElement('div');
		topRowWrapper2.classList.add('uploaded-item__top__row');

		topRowWrapper.appendChild(nameElement);
		topRowWrapper.appendChild(deleteButtonElement);

		topRowWrapper2.appendChild(sizeElement);
		topRowWrapper2.appendChild(percentElement);

		topWrapper.appendChild(iconElement);
		topRightWrapper.appendChild(topRowWrapper);
		topRightWrapper.appendChild(topRowWrapper2);

		topWrapper.appendChild(topRightWrapper);

		itemElement.appendChild(topWrapper);
		itemElement.appendChild(progressElement);

		progressWrapper.appendChild(itemElement);

		let progressPercent = 0;
		let progressInterval = setInterval(() => {
			progressPercent += 5;
			progressElement.style.width = progressPercent + '%';
			percentElement.innerText =  progressPercent + '%';

			if(progressPercent >= 100) {
				clearInterval(progressInterval);
			}
		}, 100);


	},
	bytesToText: (bytes) => {
		let size = 'KB';
		let tofixed = 0;
		bytes = bytes / 1024;
		if(bytes >= 1024) {
			bytes = bytes / 1024;
			size = 'MB';
			tofixed = 2;
		}
		return bytes.toFixed(tofixed)+size;
	},

	initComplaintFormEvents: () => {
		const formContents = document.querySelectorAll('.contact-form__complaint');
		formContents.forEach((formContent) => {
			const wpcf7Elm = formContent.closest('.wpcf7');
			if(!wpcf7Elm) return;
			wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
				cf7.showComplaintFormSendSuccess(formContent);
			}, false );

			wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
				if(typeof event.detail.apiResponse.invalid_fields[0] !== 'undefined'){
					let fieldsOrder = [
						'your-name',
						'your-surname',
						'text-pesel',
						'text-regon',
						'text-company',
						'zip-code',
						'city',
						'street',
						'street-no',
						'insurance-type',
						'complaint-type-child',
						'complaint-text',
						'email-275',
						'acceptance-basic-1',
						'acceptance-basic-2',
						'acceptance-basic-3'
					]

					let fieldName = null;
					for( let i = 0; i < fieldsOrder.length; i++ ){
						let fieldOrderName = fieldsOrder[i];
						for( let j = 0; j < event.detail.apiResponse.invalid_fields.length; j++ ){
							let invalidFieldName = event.detail.apiResponse.invalid_fields[j].field;
							if(fieldOrderName === invalidFieldName){
								fieldName = fieldOrderName;
								break;
							}
						}
						if( fieldName ) {
							break;
						}
					}

					if( ! fieldName ){
						fieldName = event.detail.apiResponse.invalid_fields[0].field;
					}
					let element = wpcf7Elm.querySelector( `.wpcf7-form-control-wrap[data-name="${fieldName}"]` )

					if( element ){
						$([document.documentElement, document.body]).animate({
							scrollTop: $(element).offset().top - 25
						}, 500 );
					}

				}
			}, false );
		})
	},
	showComplaintFormSendSuccess: (formContent) => {
		formContent.classList.add('sent');
		const heading = document.querySelector('h1.wp-block-heading');
		if(heading){
			heading.remove();
		}
	},
	fileIsValid: (file, fileInput) => {
		const filename = file.name;
		var re = /(?:\.([^.]+))?$/;
		const ext = re.exec(filename)[1];
		if(!ext) return false;
		let acceptExtensions = fileInput.getAttribute('accept');
		if(acceptExtensions){
			acceptExtensions = acceptExtensions.toLowerCase().split(',');
			if(acceptExtensions.indexOf("."+ext.toLowerCase()) === -1){
				return false;
			}
		}



		return true;
	}
}

export default cf7;
